import { type AggregationFn } from "@tanstack/react-table";

import { round } from "./aggregationFnUtils";

/**
 * NOTE: This function is called `filled` because we want it to show up as `filled` in the DataGrid
 * UI, and that is determined by the `name` field of the function.
 */
export const filled: AggregationFn<unknown> = (columnId, leafRows) => {
	let filledCount = 0;
	let totalCount = 0;
	leafRows.forEach((row) => {
		const value = row.getValue(columnId);
		totalCount += 1;
		if (value !== null && value !== "" && value !== undefined) {
			filledCount += 1;
		}
	});

	if (totalCount === 0 || filledCount === 0) {
		return "0%";
	}

	return `${round((filledCount / totalCount) * 100)}%`;
};
